import { render, staticRenderFns } from "./GenerarComprobante.vue?vue&type=template&id=147e6634"
import script from "./GenerarComprobante.vue?vue&type=script&lang=js"
export * from "./GenerarComprobante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports